<div class="app">
  <router-outlet></router-outlet>

  <app-fly-out-new-nibedon-form></app-fly-out-new-nibedon-form>
</div>